import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { YesOrNoComponent } from 'src/app/dialog/yes-or-no/yes-or-no.component';
import { JournalService } from 'src/app/services/journal.service';

@Component({
    selector: 'kt-accounting-attachment',
    templateUrl: './accounting-attachment.component.html',
    styleUrls: ['./accounting-attachment.component.css'],
})
export class AccountingAttachmentComponent implements OnInit {
    journalId: string = '';
    allFiles: File[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private notification: NotificationsService,
        private journalService: JournalService,
        private _dialog: MatDialog,
        private spinner: NgxSpinnerService,
        private dialogRef: MatDialogRef<AccountingAttachmentComponent>,
    ) {
        this.journalId = data.journalId;
        data.dataExistent.forEach((element: any) => {
            let fileSrc: any = {};
            fileSrc.id = element.id;
            fileSrc.name = element.fileName;
            fileSrc.size = element.size;
            fileSrc.previewUrl = element.previewUrl;
            fileSrc.base64 = element.base64;

            this.allFiles.push(fileSrc);
        });
    }

    ngOnInit(): void {}

    closePopup(): void {
        this.dialogRef.close();
    }

    openFile(file) {
        openFileJs(file.base64, file.name);
    }
    onFileSelected(event: any) {
        const newFiles = Array.from(event.target.files) as File[];

        newFiles.forEach((file) => {
            const alreadyExists = this.allFiles.some((f) => f.name === file.name);
            if (!alreadyExists) {
                this.allFiles.push(file);
            } else {
                this.notification.warn(`O arquivo "${file.name}" já foi adicionado.`);
                this.closePopup();
            }
        });
        event.target.value = '';
    }

    removeFile(file: any) {
        if (file.id) {
            this.yesOrNoDialog('Remover Arquivo', 'Confirmar remoção do arquivo Existente?').subscribe((resultMsg) => {
                if (resultMsg) {
                    this.spinner.show();
                    this.journalService.DeleteAttachments(file.id).subscribe((result) => {
                        this.spinner.hide();
                        if (result) {
                            this.notification.success(`Arquivo Removido !`);
                            this.allFiles = this.allFiles.filter((f) => f !== file);
                        } else {
                            this.notification.warn(`Falha ao remover arquivo`);
                        }
                    });
                }
            });
        } else {
            this.allFiles = this.allFiles.filter((f) => f !== file);
        }
    }

    downloadFile(file: any) {
        if (file.previewUrl) this.redirect(file.previewUrl);
    }

    private redirect(url: string, target = '_blank'): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            try {
                resolve(!!window.open(url, target));
            } catch (e) {
                reject(e);
            }
        });
    }
    private yesOrNoDialog(title: string, text: string): Observable<any> {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.width = '300px';
        dialogConfig.data = {
            title: title,
            text: text,
        };
        const dialogRef = this._dialog.open(YesOrNoComponent, dialogConfig);
        return dialogRef.afterClosed();
    }

    saveFiles() {
        if (this.allFiles.length === 0) {
            this.notification.warn('Nenhum arquivo selecionado!');
            return;
        }

        this.spinner.show();
        this.journalService.saveAttachment(this.journalId, this.allFiles).subscribe({
            next: (res) => {
                this.notification.success('Arquivos Adicionado!');
                this.spinner.hide();
                this.closePopup();
            },
            error: (err) => {
                this.notification.warn('Erro ao enviar arquivos:', err);
                this.spinner.hide();
            },
        });
    }

    getFileIcon(fileName: string): string {
        const ext = fileName.split('.').pop()?.toLowerCase();
        switch (ext) {
            case 'pdf':
                return 'fa fa-file-pdf fa-2x';
            case 'jpg':
            case 'jpeg':
            case 'png':
                return 'fa fa-file-image fa-2x';
            case 'doc':
            case 'docx':
                return 'fa fa-file-word fa-2x';
            case 'xls':
            case 'xlsx':
                return 'fa fa-file-excel fa-2x';
            default:
                return 'fa fa-file fa-2x';
        }
    }
}

function openFileJs(base64, fileName) {
    let typeApplication = '';
    const lowerFileName = fileName.toLowerCase();

    if (lowerFileName.endsWith('.pdf')) {
        typeApplication = 'application/pdf';
    } else if (lowerFileName.endsWith('.jpeg') || lowerFileName.endsWith('.jpg')) {
        typeApplication = 'image/jpeg';
    } else if (lowerFileName.endsWith('.png')) {
        typeApplication = 'image/png';
    } else if (lowerFileName.endsWith('.txt')) {
        typeApplication = 'text/plain';
    } else if (lowerFileName.endsWith('.docx')) {
        typeApplication = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    } else if (lowerFileName.endsWith('.xlsx')) {
        typeApplication = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    } else if (lowerFileName.endsWith('.zip')) {
        typeApplication = 'application/zip';
    } else {
        typeApplication = 'application/octet-stream';
    }

    OpenPdfByBase64(base64, typeApplication);
}

function OpenPdfByBase64(base64, typeApplication) {
    if (!typeApplication) typeApplication = 'application/pdf;base64';

    //PDF → "application/pdf"
    //JPEG → "image/jpeg"
    //PNG → "image/png"
    //TXT → "text/plain"
    //DOCX → "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    //XLSX → "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    //ZIP → "application/zip"

    if (base64) {
        let byteCharacters = atob(base64);
        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: typeApplication });
        let fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');
    }
}
